import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: LegalModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  return <AnimatePresence data-id="element-140">
      {isOpen && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-141">
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} data-id="element-142" />

          {/* Modal */}
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.3
      }} className="relative bg-white text-navy rounded-xl shadow-2xl w-full max-w-2xl max-h-[80vh] flex flex-col" data-id="element-143">
            {/* Header */}
            <div className="flex items-center justify-between p-6 border-b border-gray-200 shrink-0" data-id="element-144">
              <h2 className="text-xl font-serif font-bold" data-id="element-145">{title}</h2>
              <button onClick={onClose} className="p-2 rounded-lg hover:bg-gray-100 transition-colors" aria-label="Cerrar" data-id="element-146">
                <X className="w-5 h-5 text-gray-500" data-id="element-147" />
              </button>
            </div>

            {/* Body */}
            <div className="p-6 overflow-y-auto text-sm text-gray-700 leading-relaxed space-y-4" data-id="element-148">
              {children}
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}